import { useState, useMemo, useRef } from "react"
import { useRequest } from "ahooks";
import { Card } from "antd";
import { Table, DEFAULT_PAGE_DATA } from "../../../components/table";
import { generateTableColumns, DEFAULT_QUERY_DATA, generateQueryFormConfig } from "./config";
import { CardServer } from "../../../server";
import { EditForm } from "../../../components/editForm";
import { Operation } from "./operation";

const server = CardServer.Holder

export const CardHolder = () => {
    const operationRef: any = useRef();
    const [queryData, setQueryData] = useState<any>({ ...DEFAULT_QUERY_DATA });
    const [loading, setLoading] = useState<boolean>(false);
    const [tableData, setTableData] = useState<any[]>([]);
    const [pageData, setPageData] = useState<any>({ ...DEFAULT_PAGE_DATA });

    //获取表格数据
    const { run, refresh } = useRequest(server.list, {
        defaultParams: [{ ...pageData, ...queryData }],
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onError: () => {
            setTableData([]);
            setPageData({ ...pageData, Total: 0 });
        },
        onSuccess: (res: any) => {
            const { Total, List, Page, PageSize } = res;
            setTableData(List);
            setPageData({ Page, PageSize, Total });
        }
    });


    const getQueryFormConfig = useMemo(() => {
        return generateQueryFormConfig({});
    }, []);

    const getTableColumns = useMemo(() => {
        return generateTableColumns({ loading, operationRef });
    }, [loading, operationRef]);

    return (
        <div>
            <Card>
                <EditForm
                    componentId="card-holder-query-form"
                    loading={loading}
                    formAttrsProps={{
                        layout: 'inline',
                    }}
                    formData={queryData}
                    onDataChange={setQueryData}
                    formConfig={getQueryFormConfig}
                    onQuery={() => {
                        run({ ...DEFAULT_PAGE_DATA, ...queryData });
                    }}
                    onReset={() => {
                        setQueryData({ ...DEFAULT_QUERY_DATA });
                        run({ ...DEFAULT_QUERY_DATA, ...DEFAULT_PAGE_DATA });
                    }}
                />
            </Card>
            <Card className="mt20">
                <Table
                    loading={loading}
                    dataSource={tableData}
                    columns={getTableColumns}
                    rowKey="Id"
                    scroll={{
                        x: 'max-content'
                    }}
                    page={pageData}
                    onPageChange={(Page: number, PageSize: number) => {
                        const currentPage = { ...pageData, Page, PageSize };
                        run({ ...currentPage, ...queryData });
                    }}
                />
            </Card >
            <Operation ref={operationRef} onSuccess={refresh} />
        </div>
    );
}